import { render, staticRenderFns } from "./NewTabButton.vue?vue&type=template&id=8c48dea4&scoped=true"
import script from "./NewTabButton.vue?vue&type=script&lang=js"
export * from "./NewTabButton.vue?vue&type=script&lang=js"
import style0 from "./NewTabButton.vue?vue&type=style&index=0&id=8c48dea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c48dea4",
  null
  
)

export default component.exports